import React, { useState, useEffect, createContext } from 'react'
import styled from 'styled-components'
import SearchBar from './SearchBar'
import NewDatabaseGroupDialog from './groups/NewDatabaseGroupDialog'
import GroupDatabaseTable from './groups/GroupDatabaseTable'
import getModels from '../api/getModels'
import { getGroupModeList } from '../api/groupDatabases'
import { DatabaseModel, GroupModel } from './groups/interface/Group'


interface ContextValue{
    updateData: () => void
    databaseModels: string[]
}
export const UpdateContext = createContext<ContextValue>(null);

export default function GroupDatabase() {
    const [search, setSearch] = useState<string>('')
    const [showNewGroupModal, setShowNewGroupModal] = useState<boolean>(false)
    const [databaseModels, setDatabaseModels] = useState<DatabaseModel[]>([])
    const [groupModels, setGroupModels] = useState<GroupModel[]>([])
    const [loadingData, setLoadingData] = useState<boolean>(false)

    useEffect(() => {
        updateGroupDatabaseData()
    }, [])  

    const updateGroupDatabaseData = () => {
        setLoadingData(true)

        getModels()
            .then(responseBody => {
                setDatabaseModels([...responseBody])
            })
            .catch(error => console.log(error))

        getGroupModeList()
            .then(responseBody => {
                setGroupModels([...responseBody])
            })
            .catch(error => console.log(error))

        setLoadingData(false)
    }

    const handleChange = event => {
        setSearch(event.target.value)
    }
    
    const handleAddGroupModal = () => {
        setShowNewGroupModal(true)
    }

    const updateContextValue = {
        updateData: updateGroupDatabaseData,
        databaseModels:databaseModels
    }

    return (
        <MainContainer>
            {loadingData ? (
                <LoadingIconCenter className="fa fa-spinner fa-spin fa-4x" aria-hidden="true"></LoadingIconCenter>
            ) : (
                <>
                    <SearchContainer>
                        <Button data-cy="addNewGroup" onClick={handleAddGroupModal}>
                            <i className="fas fa-plus"></i>
                            <span>Add Group</span>
                        </Button>
                        <SearchBar onChange={handleChange} value={search} type='Group Model'></SearchBar>
                        {/* TODO:  what this filter should do, commented because it has no function in the UI*/}
                        {/* <FilterButton>
                            <i className="far fa-filter"></i>
                        </FilterButton> */}
                    </SearchContainer>
                    <UpdateContext.Provider value={updateContextValue}>
                        <NewDatabaseGroupDialog
                            show={showNewGroupModal}
                            setShowNewGroupModal={setShowNewGroupModal}
                            mode="save"
                        />
                        <GroupDatabaseTable
                            groupsModels={groupModels}
                            search = {search}
                        />
                    </UpdateContext.Provider>
                </>
            )}
        </MainContainer>
    )
}

const FilterButton = styled.div`
    width: 30px;
    height: 32px;
    margin-left: 10px;
    color: var(--blue-500);
    border: 1px solid var(--gray-400);
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const MainContainer = styled.div`
    font-family: arial, sans-serif;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    position: relative;
    background-color: var(--gray-0);
    align-items: center;
    margin: auto;;
`

const SearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 10%;
    margin: auto;
    height: 54px;
    
`

const Button = styled.button`
    width: 200px;
    margin-right: 10px;
    color: var(--gray-0);
    background-color: var(--blue-500);
    border: none;
    padding: 8px 0;
    border-radius: 3px;
    span {
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 16px;
        margin-left: 6px;
        color: var(--gray-0);
    }
    &:hover {
        color: var(--gray-0);
        background-color: var(--blue-400);
        border-color: var(--blue-700);
    }
`
const LoadingIconCenter = styled.i`
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
`
